import styled from "styled-components";

export const CardButton = styled.button<{ accentColor: string }>`
	height: 103px;
	background: #ffffff;
	border: 1px solid #dcdfe6;
	border-radius: 10px;
	padding: 21px 20px;
	box-shadow: 0 1px 2px rgba(0, 14, 75, 0.02);
	text-align: left;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	width: 100%;
	position: relative;
	overflow: hidden;
	transition: box-shadow 0.22s ease, transform 0.22s ease;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 3px;
		background-color: ${({ accentColor }) => accentColor};
	}

	&:hover {
		box-shadow: 0 5px 16px rgba(0, 14, 75, 0.08);
		transform: translateY(-1px);
	}
`;

export const Label = styled.small`
	display: block;
	color: #797d8d;
	font-size: 12px;
	font-weight: 800;
	letter-spacing: 0.35px;
	text-transform: uppercase;
	margin-bottom: 8px;
	font-family: "NotoSans-Bold", sans-serif;
`;

export const ValueContainer = styled.div`
	display: flex;
	align-items: baseline;
`;

export const Value = styled.strong`
	font-size: 36px;
	font-weight: 800;
	letter-spacing: -0.6px;
	color: #000e4b;
	line-height: 1;
	font-family: "NotoSans-ExtraBold", sans-serif;
`;

export const Unit = styled.span`
	color: #797d8d;
	font-size: 15px;
	margin-left: 7px;
	font-family: "NotoSans-Medium", sans-serif;
`;
